"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _reactMintl = require("@godaddy/react-mintl");
var _headerUtil = require("@ux/header-util");
var _x = _interopRequireDefault(require("@ux/icon/x"));
var _clickguard = _interopRequireDefault(require("./clickguard"));
var _verify = _interopRequireWildcard(require("./verify"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
//
// Delegation types.
//
// Impersonate: c3 representatives
// Delegate: shopper delegation
//
const impersonate = 'impersonate';
const delegate = 'delegate';

/**
 * Render exit links on the right side of each delegation bar.
 *
 * @class ExitLink
 * @api private
 */
class ExitLink extends _react.Component {
  /**
   * Render form to ensure a POST request to action.
   *
   * @returns {React.ReactElement} form element.
   * @api private
   */
  delegate() {
    const props = this.props;
    return /*#__PURE__*/_react.default.createElement("form", {
      method: "post",
      action: props.action
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "hidden",
      name: "secret",
      value: props.secret
    }), /*#__PURE__*/_react.default.createElement("button", {
      type: "submit",
      className: "delegate-link"
    }, /*#__PURE__*/_react.default.createElement(_x.default, null), ' ' /* deliberate space between icon and message */, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "PC:AppHeader:Header:AcctDelegationExitLabel"
    })));
  }

  /**
   * Render a simple logout link.
   *
   * @returns {React.ReactElement} anchor element.
   * @api private
   */
  impersonate() {
    return /*#__PURE__*/_react.default.createElement("a", {
      href: this.props.action,
      className: "delegate-link"
    }, /*#__PURE__*/_react.default.createElement(_x.default, null), ' ' /* deliberate space between icon and message */, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "PC:AppHeader:Header:AcctImpersonationExitLabel"
    }));
  }
  render() {
    return this[this.props.type]();
  }
}

/**
 * Default type and action for exit link.
 *
 * @enum {Object}
 * @api public
 */
ExitLink.defaultProps = {
  type: delegate
};

/**
 * Required ExitLink properties.
 *
 * @enum {Object}
 * @api public
 */
ExitLink.propTypes = {
  /** secret to populate input with */
  secret: _propTypes.default.string,
  /** render 'delegate' or 'impersonate' */
  type: _propTypes.default.string.isRequired,
  /** where the form POSTs to */
  action: _propTypes.default.string
};

/**
 * Render delegation bar.
 *
 * @class Bar
 * @api private
 */
class Bar extends _react.Component {
  render() {
    const props = this.props;
    const type = props.type;
    const wrapper = (0, _classnames.default)('delegate', {
      rep: type === impersonate
    });
    if (!props.active) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: wrapper
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, props.label), /*#__PURE__*/_react.default.createElement(ExitLink, {
      type: type,
      action: props.action,
      secret: props.secret
    }));
  }
}

/**
 * Require Bar properties.
 *
 * @enum {Object}
 * @api public
 */
Bar.propTypes = {
  /** has refreshed from cookie? */
  refreshed: _propTypes.default.bool,
  /** is delegation active? */
  active: _propTypes.default.bool,
  /** label to show with customer info */
  label: _propTypes.default.object,
  /** 'delegation' or 'impersonation' */
  type: _propTypes.default.string,
  /** exit link secret input */
  secret: _propTypes.default.string,
  /** where exit link form POSTs to */
  action: _propTypes.default.string
};

/**
 * Render internationalized delegation bars.
 *
 * @class AccountDelegation
 * @api public
 */
class AccountDelegation extends _react.Component {
  constructor(props = {}) {
    super(...arguments);

    //
    // Setup delegate instance
    //
    this.delegate = new _headerUtil.Delegate({
      data: props.delegate || {}
    });

    //
    // Keep track of the delegation type.
    //
    this._type = AccountDelegation.type || impersonate;
    this.state = {
      refreshed: false,
      credentialRefreshPending: false,
      showVerificationModal: false,
      impersonatedCustomerId: null
    };

    //
    // Expose the clickguard method on the constructor. This is safe since there
    // should only be one AccountDelegation Component on the page. Required
    // to get the localization data in the modal. Also ClickGuard cannot
    // be used without account delegation being active.
    //
    AccountDelegation.clickguard = _clickguard.default.bind(_clickguard.default, props.messages);

    //
    // Bind event listener.
    //
    this.onTabFocus = this.onTabFocus.bind(this);
  }

  /**
   * Determine type of delegating from cookie. This method is made static for
   * external consumption.
   *
   * @returns {String|Array} Account delegation type.
   * @api public
   */
  static get type() {
    const auth = AccountDelegation.idp.getIdpProperty('auth');
    switch (auth) {
      case 'e2s2s':
        return [delegate, impersonate];
      case 'e2s':
        return impersonate;
      case 's2s':
        return delegate;
      case 'e2s2snpr':
        return [delegate, impersonate];
      case 'e2snpr':
        return impersonate;
      case 's2snpr':
        return delegate;
      default:
        return 'none';
    }
  }

  /**
   * Return idp cookie reference. Also attempts to fetch latest data from cookie.
   *
   * @returns {Cookie} Header utils cookies instance.
   * @api public
   */
  static get idp() {
    if (!AccountDelegation._idp) {
      AccountDelegation._idp = new _headerUtil.Cookies();
    }
    return AccountDelegation._idp.updateIdp();
  }

  /**
   * Is delegation active?
   *
   * @returns {Boolean} Active
   * @api public
   */
  static get active() {
    return !~AccountDelegation.type.indexOf('none');
  }

  /**
   * Is the delegation of type shopper delegate.
   *
   * @returns {Boolean} shopper delegation
   * @api private
   */
  get isDelegate() {
    return !!~this._type.indexOf(delegate);
  }

  /**
   * Is the delegation of type c3 impersonation.
   *
   * @returns {Boolean} impersonation
   * @api private
   */
  get isImpersonation() {
    return !!~this._type.indexOf(impersonate);
  }

  /**
   * Label properties of delegation bar.
   *
   * @param {Boolean} [forImpersonationBar=false] Whether this label is for the impersonation bar
   * @returns {Object} data used by formatted message.
   * @api private
   */
  label(forImpersonationBar = false) {
    var _customer, _customer2, _impersonator;
    let customer, impersonator;
    if (forImpersonationBar) {
      customer = this.delegate.impersonatedCustomer || this.props.customer;
      impersonator = this.delegate;
    } else {
      // delegation bar
      customer = this.props.customer;
      impersonator = this.delegate.impersonatedCustomer || this.delegate;
    }
    // If we have a displayName set, use that.
    // If we have the customer's first and last name, pass those in so the i18n string handles localizing name order.
    // Otherwise, use the displayName method to handle fallbacks to fullName, username, or shopperId.
    let customerFirstName = ((_customer = customer) === null || _customer === void 0 ? void 0 : _customer.get) && customer.get('displayName') || '';
    let customerLastName = '';
    if ((_customer2 = customer) !== null && _customer2 !== void 0 && _customer2.get && !customerFirstName) {
      customerFirstName = customer.get('firstName');
      customerLastName = customer.get('lastName');
      if (!(customerFirstName && customerLastName)) {
        customerFirstName = customer.displayName(true);
        customerLastName = '';
      }
    }

    // TODO: Remove this check once we find the root cause of why the name is being set to 'undefined'
    // https://godaddy-corp.atlassian.net/browse/UXP-10440
    let delegateName = ((_impersonator = impersonator) === null || _impersonator === void 0 ? void 0 : _impersonator.delegateName()) || '';
    if (delegateName === 'undefined') {
      delegateName = '';
    }
    return {
      id: 'PC:AppHeader:Header:AcctDelegationLabel',
      values: {
        delegate: delegateName,
        firstName: customerFirstName,
        lastName: customerLastName
      }
    };
  }

  /**
   * Update the window title to reflect the current shopperId of the customer.
   *
   * @api private
   */
  updateTitle() {
    const {
      customer
    } = this.props;
    if (!customer || !customer.shopperId) {
      return;
    }
    let title = window.document.title;
    const i = title.indexOf(']');
    title = ~i ? title.substr(i + 2) : title;
    window.document.title = `[${customer.shopperId}] ${title}`;
  }

  /**
   * Verify consistency of credentials when a browser tab is focused.
   *
   * @api private
   */
  onTabFocus() {
    const self = this;
    const props = self.props;

    // Don't reset state if the dialog is already showing
    if (this.state.showVerificationModal) return;
    const credentialsValid = (0, _verify.default)({
      customer: props.customer
    });
    this.setState({
      showVerificationModal: !credentialsValid,
      credentialRefreshPending: false,
      credentialRefreshFailed: false
    });
  }

  /**
   * Handle click on OK button in verification modal
   *
   * @api private
   */
  onVerificationModalOkClicked() {
    const props = this.props;
    this.setState({
      credentialRefreshPending: true
    });
    (0, _verify.refreshCookie)({
      customer: props.customer,
      restoreCookie: props.restoreCookie
    }, refreshed => {
      this.setState({
        showVerificationModal: !refreshed,
        credentialRefreshPending: false,
        credentialRefreshFailed: !refreshed
      });
    });
  }

  /**
   * Get data, listen to window focus and update the title if required.
   *
   * @api private
   */
  componentDidMount() {
    this.updateDelegate();
    typeof window !== 'undefined' && window.addEventListener('focus', this.onTabFocus);
    if (this.isImpersonation) {
      this.updateTitle();
    }
    if (AccountDelegation.active && typeof document !== 'undefined') {
      document.body.classList.add('uxp-delegation');
    }
  }

  /**
   * Update delegate data from cookie.
   * @returns {void}
   * @private
   */
  updateDelegate() {
    // If the delegation type has changed, update the state
    this._type = AccountDelegation.type || impersonate;

    // Update the delegate data from the cookie
    this.delegate.updateFromCookie();

    // If there is an intermediate customer in the delegation chain, we need to set state so we re-render the
    // impersonation bar label
    if (this.delegate.impersonatedCustomer && this.state.impersonatedCustomerId !== this.delegate.impersonatedCustomer.shopperId) {
      this.setState({
        impersonatedCustomerId: this.delegate.impersonatedCustomer.shopperId
      });
    }
  }

  /**
   * Update delegate and title if required
   *
   * @api private
   */
  componentDidUpdate() {
    this.updateDelegate();
    if (this.isImpersonation) {
      this.updateTitle();
    }
  }

  /**
   * Remove window focus listener.
   *
   * @api private
   */
  componentWillUnmount() {
    if (typeof document !== 'undefined') {
      document.removeEventListener('focus', this.onTabFocus);
      document.body.classList.remove('uxp-delegation');
    }
  }

  /**
   * Render the delegation bar.
   *
   * @returns {React.ReactElement} Translated delegation bar.
   * @api private
   */
  render() {
    const state = this.state;
    const props = this.props;
    const wrapper = (0, _classnames.default)('delegation', {
      db: this.isImpersonation && this.isDelegate
    });

    //
    // Do not render the bar if there is no active delegation.
    //
    if (!AccountDelegation.active) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement(_reactMintl.IntlProvider, {
      messages: props.messages,
      textComponent: "span"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: wrapper
    }, /*#__PURE__*/_react.default.createElement(Bar, (0, _extends2.default)({}, props, {
      type: impersonate,
      refreshed: state.refreshed,
      label: this.label(true),
      active: this.isImpersonation
    })), /*#__PURE__*/_react.default.createElement(Bar, (0, _extends2.default)({}, props, {
      type: delegate,
      refreshed: state.refreshed,
      label: this.label(false),
      active: this.isDelegate
    })), this.state.showVerificationModal && /*#__PURE__*/_react.default.createElement(_verify.VerificationModal, {
      displayName: props.customer.displayName(),
      shopperId: props.customer.shopperId,
      pending: this.state.credentialRefreshPending,
      refreshFailed: this.state.credentialRefreshFailed,
      onDismiss: () => {
        this.setState({
          showVerificationModal: false
        });
      },
      onOk: this.onVerificationModalOkClicked.bind(this)
    })));
  }
}

/**
 * Default type and action for exit link.
 *
 * @enum {Object}
 * @api public
 */
exports.default = AccountDelegation;
AccountDelegation.defaultProps = {
  action: 'https://sso.godaddy.com/cookie/switchback/',
  restoreCookie: 'https://sso.godaddy.com/cookie/restore/'
};

/**
 * Allowed delegation values.
 *
 * @enum {Object}
 * @api public
 */
AccountDelegation.propTypes = {
  /** delegated customer data */
  customer: _propTypes.default.object,
  /** data to initialize the Delegate instance with */
  delegate: _propTypes.default.object,
  /** secret to populate exit link input with */
  secret: _propTypes.default.string,
  /** cookie to attempt to refresh from */
  restoreCookie: _propTypes.default.string,
  /** current market */
  market: _propTypes.default.string.isRequired,
  /** delegation strings */
  messages: _propTypes.default.object.isRequired,
  /** exit link POST action */
  action: _propTypes.default.string
};